// Generic account-invitation client. Used by the accept-invitation page so the
// same UI works for any user type (agent today; renter / owner / future types
// later) — only the user_type-aware copy on the page changes.
import { buildApiUrl, debugLog } from '../config/environment';

// Fetch a summary of the invitation by token (public endpoint).
// Returns { email, given, surname, user_type, agency_name?, expires_at }.
// Throws when the invitation is missing / expired / accepted / cancelled.
export const getInvitation = async (token) => {
  debugLog('Fetching invitation summary for token');

  const response = await fetch(
    buildApiUrl(`/account-invitations/${encodeURIComponent(token)}`),
    { method: 'GET', headers: { 'Content-Type': 'application/json' } }
  );

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    const err = new Error(text || 'Invitation lookup failed');
    err.status = response.status;
    throw err;
  }
  return response.json();
};

// Accept an invitation by token (public endpoint).
// Returns { email, user_type, message }. No JWT is issued — the page should
// redirect the user to /login on success.
export const acceptInvitation = async (token) => {
  debugLog('Accepting invitation');

  const response = await fetch(buildApiUrl('/account-invitations/accept'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    const err = new Error(text || 'Failed to accept invitation');
    err.status = response.status;
    throw err;
  }
  return response.json();
};

